import { Component } from '@angular/core';

@Component({
	selector: 'perf-fund-performance-skeleton',
	templateUrl: './fund-performance-skeleton.component.html',
	styleUrls: ['./fund-performance-skeleton.component.scss']
})
export class FundPerformanceSkeletonComponent {

	public readonly TABLES_ON_TAB = Array(5).fill(0);
	public readonly GHOST_ROWS = Array(5).fill(0);
	public readonly GHOST_COLUMNS = Array(9).fill(0);

}
